module.exports = __webpack_public_path__ + "img/before4.c93b5032.png";